"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckmarkStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _ursaIcons = require("@smartsheet/ursa-icons");
const CheckmarkStyled = (0, _styled.default)(_ursaIcons.Icon)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;
exports.CheckmarkStyled = CheckmarkStyled;
//# sourceMappingURL=CheckmarkStyled.js.map